export enum ApiKeyType {
  DASHBOARD = 'DASHBOARD',
  EXPORT_TABLE = 'EXPORT_TABLE'
}

export type ApiKey = {
  id: string
  name: string
  value: string
  type: ApiKeyType
}
